"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flyout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flyout = require("./Flyout.styles");

var _clickOutside = _interopRequireDefault(require("../../hooks/click-outside"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Flyout = ({
  children,
  className,
  id,
  show,
  onOutsideClick,
  placement,
  offset = 0,
  items,
  onSelect,
  width,
  ...props
}) => {
  const [styles, setStyles] = (0, _react.useState)({});
  const fRef = (0, _react.useRef)(null);
  (0, _clickOutside.default)(fRef, () => {
    if (typeof onOutsideClick === 'function') onOutsideClick();
  }, show);
  const getPosition = (0, _react.useCallback)((event, id) => {
    let styles = {};
    const element = document.getElementById(id);
    const params = element && element.getBoundingClientRect();
    const flyoutDetails = fRef.current && fRef.current.getBoundingClientRect();

    if (!params || !flyoutDetails) {
      styles.left = event && event.clientX || 0;
      styles.top = event && event.clientY || 0;
      return styles;
    }

    const leftPosition = params.x + (checkWindow() ? window.scrollX : 0);

    switch (placement) {
      case 'leftTop':
        styles.left = leftPosition - flyoutDetails.width - offset;
        styles.top = params.y + (checkWindow() ? window.scrollY : 0);
        break;

      case 'leftCenter':
        styles.left = leftPosition - flyoutDetails.width - offset;
        styles.top = params.y + params.height / 2 - flyoutDetails.height / 2 + (checkWindow() ? window.scrollY : 0);
        break;

      case 'leftBottom':
        styles.left = leftPosition - flyoutDetails.width - offset;
        styles.top = params.y + params.height - flyoutDetails.height + (checkWindow() ? window.scrollY : 0);
        break;

      case 'topLeft':
        styles.left = leftPosition;
        styles.top = params.y - flyoutDetails.height - offset + (checkWindow() ? window.scrollY : 0);
        break;

      case 'topCenter':
        styles.left = leftPosition + params.width / 2 - flyoutDetails.width / 2;
        styles.top = params.y - flyoutDetails.height - offset + (checkWindow() ? window.scrollY : 0);
        break;

      case 'topRight':
        styles.left = leftPosition + params.width - flyoutDetails.width;
        styles.top = params.y - flyoutDetails.height - offset + (checkWindow() ? window.scrollY : 0);
        break;

      case 'rightTop':
        styles.left = leftPosition + params.width + offset;
        styles.top = params.y + (checkWindow() ? window.scrollY : 0);
        break;

      case 'rightCenter':
        styles.left = leftPosition + params.width + offset;
        styles.top = params.y + params.height / 2 - flyoutDetails.height / 2 + (checkWindow() ? window.scrollY : 0);
        break;

      case 'rightBottom':
        styles.left = leftPosition + params.width + offset;
        styles.top = params.y + params.height - flyoutDetails.height + (checkWindow() ? window.scrollY : 0);
        break;

      case 'bottomLeft':
        styles.left = leftPosition;
        styles.top = params.y + params.height + offset + (checkWindow() ? window.scrollY : 0);
        break;

      case 'bottomCenter':
        styles.left = leftPosition + params.width / 2 - flyoutDetails.width / 2;
        styles.top = params.y + params.height + offset + (checkWindow() ? window.scrollY : 0);
        break;

      case 'bottomRight':
        styles.left = leftPosition + params.width - flyoutDetails.width;
        styles.top = params.y + params.height + offset + (checkWindow() ? window.scrollY : 0);
        break;

      default:
        styles.left = leftPosition;
        styles.top = params.y + params.height + offset + (checkWindow() ? window.scrollY : 0);
    }

    return styles;
  }, [offset, placement]);
  const handleClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    setTimeout(() => {
      if (fRef.current) {
        const positionStyle = getPosition(event, id);
        setStyles({
          position: 'absolute',
          ...positionStyle
        });
      }
    }, 0);
  }, [id, getPosition]);
  (0, _react.useEffect)(() => {
    const element = document.getElementById(id);

    if (element) {
      element.addEventListener('click', handleClick);
      return () => {
        element.removeEventListener('click', handleClick);
      };
    }
  }, [id, handleClick]);

  const handleOnSelect = (event, item) => {
    event.stopPropagation();
    onSelect(item);
  };

  return show ? /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_Flyout.StyledFlyout, _extends({}, props, {
    className: (0, _classnames.default)({
      active: show,
      [className]: className
    }),
    ref: fRef,
    style: styles,
    width: width,
    "data-target": id
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content-inner"
  }, items && Array.isArray(items) && items.length ? items.map((item, index) => /*#__PURE__*/_react.default.createElement(_Flyout.StyledFlyoutItem, {
    onClick: event => handleOnSelect(event, item),
    key: index
  }, item.label)) : children && children))), document.body) : null;
};

exports.Flyout = Flyout;
Flyout.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  show: _propTypes.default.bool,
  onOutsideClick: _propTypes.default.func,
  placement: _propTypes.default.string,
  offset: _propTypes.default.number,
  items: _propTypes.default.array,
  onSelect: _propTypes.default.func,
  width: _propTypes.default.string
};

const checkWindow = () => typeof window !== undefined;